module.exports = __webpack_public_path__ + "static/media/jump-page-mobile-en.4414041a.png";